export const getApiBase = () => {
  if (
    typeof window !== "undefined" && window.location.hostname === "localhost"
  ) {
    return "http://localhost:8000";
  }
  return "https://api.view-chat.com";
};
